module.exports = {
      id: "icon-filter-usage",
      viewBox: "0 0 29.306 29.306",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-filter",
      toString: function () {
        return this.url;
      }
    }